import { QRCodeSVG } from 'qrcode.react';

import logo from 'src/assets/logo.svg';

import { Props } from './PrintableQRCode.types';

// we need to use inline styles because iframe won't have access to app styles

const PX_SIZE = 200 / 4.6;

const PrintableQRCode = ({ url, topText, bottomText, cmSize }: Props) => {
  const size = cmSize * PX_SIZE;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        border: '1px dotted black',
        borderRadius: '8px',
        width: `${size}px`,
        padding: '16px',
      }}
    >
      <div
        style={{
          fontFamily: 'Public Sans',
          fontSize: size / 8,
          fontStyle: 'normal',
          fontWeight: '500',
          color: 'black',
          textAlign: 'center',
        }}
      >
        {topText}
      </div>
      <QRCodeSVG
        value={url}
        size={size - 32}
        level="H"
        imageSettings={{ src: logo, height: size / 8, width: size / 8, excavate: true }}
        fgColor={'#114B50'}
      />
      <div
        style={{
          fontFamily: 'Public Sans',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: '500',
          color: 'black',
          textAlign: 'center',
        }}
      >
        {bottomText}
      </div>
    </div>
  );
};

export default PrintableQRCode;
